<div class="header">
  <div class="titleActions">
    <h2 mat-dialog-title>{{ data.shareTitle }}</h2>
    <div class="actions">
      <button type="button" mat-icon-button color="warn" [matTooltip]="'common.close' | t" (click)="closeDialog()">
        <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
      </button>
    </div>
  </div>
  <div class="searchFilters">
    <form class="searchBar">
      <input [placeholder]="'common.search' | t" [formControl]="searchControl" />
      <sn-icon-button
        icon="search"
        type="submit"
        [matTooltip]="'common.search' | t"
        class="sn-searchbar__search-button"
      >
      </sn-icon-button>
      <sn-icon-button
        icon="close"
        [matTooltip]="'common.clearSearch' | t"
        class="sn-searchbar__clear-button"
        (click)="clear()"
      >
      </sn-icon-button>
    </form>
  </div>
</div>

<!-- 
  Note: We're not using sn-form here because it causes application freezing when combined with TranslationModule 
  in this standalone component context. TO-DO: Convert back to sn-form when we have a better solution 
  https://taserintl.atlassian.net/browse/FWX-2924
-->
<mat-tab-group (selectedTabChange)="changeTab($event)">
  <mat-tab [label]="'common.users' | t">
    <div class="team-list-form">
      <div class="filter-section">
        <div class="filter-mode-box">
          <mat-radio-group [(ngModel)]="formModel.mode" (change)="onModeChange()" class="filter-radio-group">
            <mat-radio-button value="team">{{ 'incidentManagement.filter.filterByTeam' | t }}</mat-radio-button>
            <mat-radio-button value="chatChannel">{{ 'incidentManagement.filter.filterByChannel' | t }}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="formModel.mode === 'team'">
          <mat-form-field appearance="outline" class="team-select-field">
            <mat-label>{{ 'incidentManagement.filter.filterByTeams' | t }}</mat-label>
            <mat-select [(ngModel)]="formModel.team" (selectionChange)="onTeamSelectChange($event.value)">
              <mat-option [value]="null">{{ 'common.teams' | t }}</mat-option>
              <mat-option *ngFor="let team of teams" [value]="team">{{ team.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="formModel.mode === 'chatChannel'">
          <mat-form-field appearance="outline" class="channel-select-field">
            <mat-label>{{ 'incidentManagement.filter.filterByChatChannel' | t }}</mat-label>
            <mat-select [(ngModel)]="formModel.chatChannel" (selectionChange)="onChannelSelectChange($event.value)">
              <mat-option [value]="null">{{ 'common.chatChannel' | t }}</mat-option>
              <mat-option *ngFor="let channel of channels" [value]="channel">{{ channel.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="global-permissions-box">
        <mat-checkbox [(ngModel)]="allCanView">
          {{ 'incidentManagement.share.allCanView' | t }}
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="allCanEdit">
          {{ 'incidentManagement.share.allCanEdit' | t }}
        </mat-checkbox>
      </div>
    </div>
    <sn-data-list #listElement reloadByQueryParams [fetchFn]="loadData">
      <sn-infinite-scroll windowScrollTarget>
        <sn-pull-to-refresh>
          <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="table"></ng-template>
          <ng-template
            [ngIf]="!list.dataSource.data.length && list.dataIsInited"
            [ngIfThen]="emptyList"
          ></ng-template>
        </sn-pull-to-refresh>
      </sn-infinite-scroll>
    </sn-data-list>
  </mat-tab>
  <mat-tab [label]="'common.permissionGroups' | t">
    <sn-data-list #permissionListElement reloadByQueryParams [fetchFn]="loadPermissionData">
      <sn-infinite-scroll windowScrollTarget>
        <sn-pull-to-refresh>
          <ng-template
            [ngIf]="permissionList.dataSource.data.length"
            [ngIfThen]="groupsTable"
          ></ng-template>
          <ng-template
            [ngIf]="!permissionList.dataSource.data.length && permissionList.dataIsInited"
            [ngIfThen]="emptyList"
          ></ng-template>
        </sn-pull-to-refresh>
      </sn-infinite-scroll>
    </sn-data-list>
  </mat-tab>
  <ng-container *ngIf="shouldShowOrganizationTab">
    <mat-tab [label]="'common.organizations' | t">
      <div class="team-list-form">
        <mat-checkbox
          class="mat-menu-item isLaw-Enforcement-checkbox"
          (click)="$event.stopPropagation()"
          (change)="isEnforcementPlan($event)"
          [checked]="isLawEnforcementPlan"
        >
          {{ 'map.layers.filterByLawEnforcementAgencies' | t }}
        </mat-checkbox>
      </div>
      <sn-data-list #crossOrgListElement reloadByQueryParams [fetchFn]="loadCrossOrgData">
        <sn-infinite-scroll windowScrollTarget>
          <sn-pull-to-refresh>
            <ng-template
              [ngIf]="crossOrgList?.dataSource.data.length"
              [ngIfThen]="crossOrgTable"
            ></ng-template>
            <ng-template
              [ngIf]="!crossOrgList?.dataSource.data.length && crossOrgList?.dataIsInited"
              [ngIfThen]="emptyList"
            ></ng-template>
          </sn-pull-to-refresh>
        </sn-infinite-scroll>
      </sn-data-list>
    </mat-tab>
  </ng-container>
</mat-tab-group>

<ng-template #table>
  <sn-dolp-share-table
    [columns]="columns"
    [items]="list.dataSource.data"
    [originalAccess]="originalAccess"
    [sort]="sort"
    [sortDirection]="sortDirection"
    (sortChange)="onSortChange($event)"
  >
  </sn-dolp-share-table>
</ng-template>

<ng-template #groupsTable>
  <sn-dolp-share-group-table
    [columns]="groupColumns"
    [items]="permissionList.dataSource.data"
    [originalAccess]="originalAccess"
    [sort]="sort"
    [sortDirection]="sortDirection"
    (sortChange)="onSortChange($event)"
  >
  </sn-dolp-share-group-table>
</ng-template>

<ng-template #crossOrgTable>
  <sn-dolp-share-crossorg-table
    [columns]="crossOrgColumns"
    [items]="crossOrgList.dataSource.data"
    [originalAccess]="originalAccess"
    [sort]="sort"
    [sortDirection]="sortDirection"
    (sortChange)="onSortChange($event)"
  >
  </sn-dolp-share-crossorg-table>
</ng-template>

<ng-template #emptyList>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ 'common.noResultsMatchSearch' | t }}
  </sn-empty-state>
</ng-template>
